import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from 'components/atoms/Icon/';
import { Container, Row, Col } from 'reactstrap';
import { injectIntl } from 'react-intl';

// Components
import Button from 'components/atoms/Button';

import './AppointmentFlowFooter.scss';

const ns = 'appointment-flow-footer';

const AppointmentFlowFooter = ({
  buttonDisabled,
  onClick,
  buttonText,
  children,
  extraCol,
  className,
  buttonGridSystem,
  intl,
  ariaLabel,
  readOnly,
  buttonId
}) => {
  const classProps = cn(ns, className, {
    [`${ns}--disabled`]: buttonDisabled,
    [`${ns}--read-only`]: readOnly
  });
  const { xs, sm, md, lg, xl } = buttonGridSystem;
  const buttonAriaLabel =
    ariaLabel || ariaLabel === ''
      ? ariaLabel
      : intl.formatMessage({
          id: 'c8.aria.continue.button',
          defaultMessage: 'Continue to next step button'
        });
  const continueButtonId = buttonId || 'continue_button';
  return (
    <Container fluid={true} className={classProps} onClick={onClick}>
      <Row>
        {extraCol()}
        <Col
          className={`${ns}__right`}
          sm={sm}
          xs={xs}
          md={md}
          lg={lg}
          xl={xl}
          role={'navigation'}
        >
          <Button
            buttonTheme="link"
            className={`${ns}__continue-button`}
            disabled={buttonDisabled}
            id={continueButtonId}
            aria-label={buttonAriaLabel}
          >
            {children}
            <Icon
              type="arrow__forward"
              className={`${ns}__icon`}
              aria-hidden={true}
            />
            <div className={`${ns}__movealong-text`} aria-hidden={true}>
              {buttonText}
            </div>
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

AppointmentFlowFooter.propTypes = {
  buttonDisabled: PropTypes.bool,
  buttonGridSystem: PropTypes.object,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  extraCol: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  intl: PropTypes.object,
  ariaLabel: PropTypes.string,
  readOnly: PropTypes.bool,
  buttonId: PropTypes.string
};

AppointmentFlowFooter.defaultProps = {
  className: '',
  extraCol: () => {},
  buttonGridSystem: {},
  buttonId: ''
};

export default injectIntl(AppointmentFlowFooter);



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentFlowFooter/AppointmentFlowFooter.js